var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 16.1786C27.75 23.4569 18.1098 35.1429 15 39C11.8902 35.1429 2.25 23.4569 2.25 16.1786C2.25 8.90025 7.95837 3 15 3C22.0416 3 27.75 8.90025 27.75 16.1786Z",
    fill: "#DE0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 23.5V17.5M10.75 17.5V10M10.75 17.5L12.603 17.1294C13.8409 16.8818 15.1241 16.9996 16.2962 17.4685C17.5664 17.9765 18.9643 18.0714 20.2915 17.7396L20.4523 17.6994C20.9211 17.5822 21.25 17.161 21.25 16.6778V11.1525C21.25 10.5671 20.6998 10.1375 20.1319 10.2795C18.9085 10.5854 17.6198 10.4979 16.4489 10.0296L16.2962 9.96848C15.1241 9.49963 13.8409 9.38182 12.603 9.6294L10.75 10M10.75 10V8.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishPin);
export default __webpack_public_path__ + "static/media/finish-pin.c9cefe15956b908d58e76801586aaf81.svg";
export { ForwardRef as ReactComponent };